// Bootstrap
import swal from "sweetalert2";

require('../../bootstrap');
require('../../_shared/functions');

// Slick
require('slick-carousel');
require('slick-lightbox');

require('jquery.easing');
require('../../jquery.isonscreen.min');

/* FontAwesome */
import fontawesome from '@fortawesome/fontawesome';
import regular from '@fortawesome/fontawesome-free-regular';
import solid from '@fortawesome/fontawesome-free-solid';
import brands from '@fortawesome/fontawesome-free-brands';

fontawesome.library.add(regular);
fontawesome.library.add(solid);
fontawesome.library.add(brands);

/* Alpine.js */
import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

/**
 * Number.prototype.format(n, x, s, c)
 *
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
Number.prototype.format = function(n, x, s, c) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
        num = this.toFixed(Math.max(0, ~~n));
    return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};


let resizeTimer;
$(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        equalHeights();
    }, 100);
});


function countUp(facts_scrolled) {
    $('.countUp').each(function () {
        if (facts_scrolled[$(this).attr('data-countid')] === undefined && $(this).isOnScreen()) {

            let $this = $(this),
                countTo = $this.attr('data-count');
            // let n = (countTo - Math.floor(countTo) !== 0) ? 1 : 0;
            let n = (countTo.toString().split('.')[1] || '').length;

            // console.log((parseFloat(countTo).toString().split('.')[1] || '').length);

            $({countNum: 0}).animate({
                    countNum: countTo
                },
                {
                    duration: Math.floor(Math.random() * 5000) + 3000,
                    easing: 'easeOutQuad',
                    step: function () {
                        // $this.text(Math.floor(this.countNum).format(0, 3, '.', ','));
                        $this.text((this.countNum).format(n, 3, '.', ','));
                        facts_scrolled[$this.attr('data-countid')] = 'true';
                    },
                    complete: function () {
                        // $this.text(Math.floor(this.countNum).format(0, 3, '.', ','));
                        $this.text((this.countNum).format(n, 3, '.', ','));
                        facts_scrolled[$this.attr('data-countid')] = 'true';
                    }
                });
        }

    });
}

let facts_scrolled = [];

$(window).on('scroll', function (e) {
    countUp(facts_scrolled);
});

$(window).on('load', function (e) {
    countUp(facts_scrolled);
});

$(document).bind('mouseup touchend', function(e) {
    let container = $("div.sticky-header--desktop-navigation ul.navigation--main");
    // let containerbtn = $(".floating-btn");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        $('div.sticky-header--desktop-navigation ul.navigation--main li.parentnav').removeClass('hover');
    }
});

$(document).bind('mouseup touchend', function(e) {
    let container = $("a.card-image");
    // let containerbtn = $(".floating-btn");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        $('a.card-image').removeClass('hover');
    }
});

$(document).ready(function() {

    $('[data-action=delete-file]').click(function(e) {

        e.preventDefault();

        var el = $(this);
        var target = el.data('target');
        var route = el.data('route');

        axios.get(route)
            .then((response) =>  {
                $(target).remove();
            })
            .catch(() => {
                swal(
                    'Fehler!',
                    'Es ist ein Fehler aufgetreten!',
                    'error'
                )
            });
    });

    equalHeights();

    $('.loading-page').show();
    countUp(facts_scrolled);

    $('a.card-image').on("touchstart", function (e) {
        'use strict'; //satisfy code inspectors
        let link = $(this); //preselect the link
        if (link.hasClass('hover')) {
            return true;
        }
        else {
            link.addClass('hover');
            $('a.card-image').not(this).removeClass('hover');
            e.preventDefault();
            return false; //extra, and to make sure the function has consistent return points
        }
    });

    $('.btn-search').on('click', function(e) {
        e.preventDefault();
        if($('#mobile-search--container').hasClass('active')) {
            $('#mobile-search--container').removeClass('active');
            $('.btn-search').removeClass('active');
            $('body').removeClass('nav-overflow');
        } else {
            $('#mobile-search--container').addClass('active');
            $('.btn-search').addClass('active');
            $('body').removeClass('nav-overflow');

            $('#mobile-nav--container').removeClass('active');
            $('.menu-open').addClass('show');
            $('.menu-open').removeClass('hide');
            $('.menu-close').removeClass('show');
            $('.menu-close').addClass('hide');
            $('.btn-nav').removeClass('active');
        }
    });

    $('.btn-nav').on('click', function(e) {
        e.preventDefault();
        if($('#mobile-nav--container').hasClass('active')) {
            $('#mobile-nav--container').removeClass('active');
            $('.menu-open').addClass('show');
            $('.menu-open').removeClass('hide');
            $('.menu-close').removeClass('show');
            $('.menu-close').addClass('hide');
            $('.btn-nav').removeClass('active');
            $('body').removeClass('nav-overflow');
        } else {
            $('#mobile-nav--container').addClass('active');
            $('.menu-open').removeClass('show');
            $('.menu-open').addClass('hide');
            $('.menu-close').addClass('show');
            $('.menu-close').removeClass('hide');
            $('.btn-nav').addClass('active');
            $('body').addClass('nav-overflow');

            $('#mobile-search--container').removeClass('active');
            $('.btn-search').removeClass('active');
        }
    });

    /* Transitions Only After Page Load */
    $('body').removeClass('preload');

    $(window).resize(function () {
        $('.slider').not('.slick-initialized').slick('resize');
    });

    $(window).on('orientationchange', function () {
        $('.slider').not('.slick-initialized').slick('resize');
    });

    /* Slick Lightbox */
    $('.lightbox').slickLightbox({
        src: 'href',
        itemSelector: ' a',
        caption: 'caption'
    });


    $('[data-action=load]').click(function(e) {
        e.preventDefault();
        let el = $(this);
        axios.post(el.data('href'), {})
            .then((response) =>  {
                //console.log(response.data);
                $(el.data('target')).html(response.data);
            });


    });

    window.livewire.onError(statusCode => {
        if (statusCode === 419 || statusCode === 404 || statusCode === 500) {
            return false
        }
    });

});

function checkGrid() {
    if ($(window).width() >= 1200) return 'XL';
    if ($(window).width() >=  992) return 'LG';
    if ($(window).width() >=  768) return 'MD';
    if ($(window).width() >=  576) return 'SM';
    return 'XS';
}

function setEqualHeights(children) {
    let fixedHeight = 0;
    children.each(function (i, c) {
        $(c).attr('style', ''); // reset
        let height = $(c).outerHeight();
        if ( height > fixedHeight ) {
            fixedHeight = height;
        }
    });

    children.each(function (i, c) {
        $(c).css({'height': fixedHeight + "px"});
    });
}

function equalHeights() {

    if (checkGrid() !== 'XS') {
        $('[data-eqh-parent]').each(function (i, p) {

            //console.log(i);
            let eqhGroups = {};
            let children = $(p).find('[data-eqh]');

            //console.log(children);
            children.each(function (i, c) {
                let eqh = $(c).data('eqh');
                if(eqhGroups[eqh]) {
                    eqhGroups[eqh].push($(c));
                } else {
                    eqhGroups[eqh] = $(c);
                }
                //console.log(eqh);
            });

            $.each(eqhGroups, function(i, g){
                setEqualHeights(g);
            });

        });
    }
}
